import { omitName } from './OmitName'

const META_DESCRIPTION_MAX_LENGTH = 120

// 改行・連続する空白を1つの半角スペースにまとめたうえで、
// (自己紹介文等はHTMLではないプレーンテキストのため、< > を含む文字列もそのまま残す)
// 空文字なら fallback、120文字を超えるものは省略記号付きで切り詰める
export const buildMetaDescription = (text: string | null | undefined, fallback: string): string => {
  const normalized = (text ?? '')
    .replace(/\r?\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

  return normalized === '' ? fallback : omitName(normalized, META_DESCRIPTION_MAX_LENGTH)
}
